import {
  SimulatePayload,
  SimulateLaunchOptions,
  SimulatePayloadSchema,
} from '../../../shares/model/simulate';
import validateGameOtpConfig from '../../../shares/lib/validateGameOtpConfig';
import OTPService from '../../../entities/playForRealGame/OTPService';
import { getSDKConfig } from '../../../shares/lib/getSDKConfig';
import { assert } from 'superstruct';

export async function prepareSelectionsPayload(
  options: SimulateLaunchOptions,
): Promise<SimulatePayload> {
  // JWT Mode
  if (options.payload) {
    const payload: SimulatePayload = {
      type: 'simulate-with-jwt',
      pm: options.payload,
    };

    assert(payload, SimulatePayloadSchema);

    return payload;
  }

  // OTP Mode
  const { tenantId, simulate, locale } = getSDKConfig();
  const configTenantId = simulate?.tenantId ? simulate?.tenantId : tenantId;
  const otpCode = await getOTPForPayload();

  const payload: SimulatePayload = {
    tenant_id: configTenantId,
    otp: otpCode,
    stake: options.stake || 0,
    locale: locale?.language,
    source: simulate?.source,
    page: simulate?.pageToRedirect,
    selections: options.selections || [],
    bet_type: options.bet_type || 'live',
  };

  assert(payload, SimulatePayloadSchema);

  return payload;
}

export async function getOTPForPayload() {
  const swipeSDKConfig = getSDKConfig();

  const isValid = validateGameOtpConfig(swipeSDKConfig.otpConfig);

  if (!isValid) {
    throw new Error('OTP Config not valid');
  }

  const simulateGameId = process.env.NX_SIMULATE_GAME_ID;

  const otpService = new OTPService(swipeSDKConfig.otpConfig);
  const responseOTP = await otpService.getOTP(simulateGameId);

  if (!responseOTP) {
    throw new Error('OTP Not Found');
  }

  return responseOTP;
}
